import { getDocument, GlobalWorkerOptions } from 'pdfjs-dist';
import workerUrl from 'pdfjs-dist/build/pdf.worker.min.mjs?url';

// Vite serves the worker that matches the installed pdfjs-dist version
GlobalWorkerOptions.workerSrc = workerUrl;

/**
 * Converts a PDF (from URL or base64) to an array of PNG data URLs (one per page).
 * @param onPage Optional progress callback, called after each page renders
 */
export async function pdfToImages(
  pdfUrl: string,
  scale: number = 1.5,
  onPage?: (page: number, total: number) => void
): Promise<string[]> {
  try {
    const pdf = await getDocument(pdfUrl).promise;
    const images: string[] = [];
    for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
      try {
        const page = await pdf.getPage(pageNum);
        const viewport = page.getViewport({ scale });
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        if (!context) throw new Error('Could not get canvas context');
        canvas.width = viewport.width;
        canvas.height = viewport.height;
        await page.render({ canvasContext: context, viewport }).promise;
        images.push(canvas.toDataURL('image/png', 1.0));
        onPage?.(pageNum, pdf.numPages);
      } catch (pageError: any) {
        throw new Error(`Failed to process page ${pageNum}: ${pageError?.message || 'Unknown error'}`);
      }
    }
    if (images.length === 0) throw new Error('No images were generated from the PDF');
    return images;
  } catch (error: any) {
    throw new Error(`Failed to convert PDF to images: ${error?.message || 'Unknown error'}`);
  }
}
